import { render, staticRenderFns } from "./WeekStar.vue?vue&type=template&id=31fdb72c&scoped=true&"
import script from "./WeekStar.vue?vue&type=script&lang=js&"
export * from "./WeekStar.vue?vue&type=script&lang=js&"
import style0 from "./WeekStar.vue?vue&type=style&index=0&id=31fdb72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fdb72c",
  null
  
)

export default component.exports